import { get } from "svelte/store";
import { doLogout } from "../store/auth/auth";
import { errorMessage, token as jwttoken } from "../store/store";
import { api } from "./helpers";

async function client(
	endpoint,

	{
		method = "GET",
		version,
		params,
		data,
		token = get(jwttoken),
		header = "json",
		forceLogout = doLogout,
		onError = (_error: any) => {},
		onSuccess = (_response: any) => {},
		responseType,
	}: {
		method: string;
		version: string;
		params?: any;
		data?: any;
		token?: string | null;
		header?: string;
		forceLogout?: any;
		onError?: (error: any) => any;
		onSuccess?: (response: any) => any;
		responseType?: string;
	}
) {
	if (!token) {
		// temp fix for force logout issue
		token = localStorage.getItem("token");
	}
	return api(
		endpoint,
		version,
		method,
		data,
		params,
		token,
		header,
		responseType
	)
		.then((response) => {
			onSuccess(response);
			errorMessage.set("");
			return response;
		})
		.catch((error) => {
			onError(error);
			if (
				error.response?.status === 401 ||
				error.response?.status === 498
			) {
				forceLogout();
				throw new Error("Unauthorized!");
			}
			throw error;
		});
}

export default client;
